import { Box, Collapse } from '@mui/material';
import React from 'react';
import { IDocumentDownloaded } from '../../Interfaces/IDocumentDownloaded';
import { IDocumentRequested } from '../../Interfaces/IDocumentRequested';
import { IDocumentUploaded } from '../../Interfaces/IDocumentUploaded';
import { ILegalClient } from '../../Interfaces/ILegalClient';
import { ILegalClientLog } from '../../Interfaces/ILegalClientLog';
import { IMetadataLogin } from '../../Interfaces/IMetadataLogin';
import { ComposedChartLogin } from './ComposedChartLogin';
import { ComposedDocuments } from './ComposedDocuments';
import { PieChartBrowsers } from './PieChartBrowsers';
import { PieChartLoggedUser } from './PieChartLoggedUser';
import { PieChartOS } from './PieChartOS';
import { PieChartUser } from './PieChartUser';

interface IProps {
  activeDashboard: string[];
  setActiveDashboard: Function;
}

export const ClientDasboard: React.FC<IProps> = ({
  activeDashboard,
  setActiveDashboard,
}) => {
  const checkIsSet = (key: string) => {
    return activeDashboard.indexOf(key) > -1;
  };

  if (activeDashboard.length === 0) {
    return <></>;
  }

  return (
    <>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        <Collapse
          in={checkIsSet('PieChartLoggedUser')}
          collapsedSize={0}
          orientation='horizontal'
        >
          <PieChartLoggedUser
            keyName='PieChartLoggedUser'
            activeDashboard={activeDashboard}
            setActiveDashboard={setActiveDashboard}
          />
        </Collapse>

        <Collapse
          in={checkIsSet('PieChartUser')}
          collapsedSize={0}
          orientation='horizontal'
        >
          <PieChartUser
            keyName='PieChartUser'
            activeDashboard={activeDashboard}
            setActiveDashboard={setActiveDashboard}
          />
        </Collapse>

        <Collapse
          in={checkIsSet('ComposedChartLogin')}
          collapsedSize={0}
          orientation='horizontal'
        >
          <ComposedChartLogin
            metadataLoginArray={[]}
            keyName='ComposedChartLogin'
            activeDashboard={activeDashboard}
            setActiveDashboard={setActiveDashboard}
          />
        </Collapse>

        <Collapse
          in={checkIsSet('ComposedDocuments')}
          collapsedSize={0}
          orientation='horizontal'
        >
          <ComposedDocuments
            keyName='ComposedDocuments'
            activeDashboard={activeDashboard}
            setActiveDashboard={setActiveDashboard}
          />
        </Collapse>

        <Collapse
          in={checkIsSet('PieChartBrowsers')}
          collapsedSize={0}
          orientation='horizontal'
        >
          <PieChartBrowsers
            keyName='PieChartBrowsers'
            activeDashboard={activeDashboard}
            setActiveDashboard={setActiveDashboard}
          />
        </Collapse>

        <Collapse
          in={checkIsSet('PieChartOS')}
          collapsedSize={0}
          orientation='horizontal'
        >
          <PieChartOS
            keyName='PieChartOS'
            activeDashboard={activeDashboard}
            setActiveDashboard={setActiveDashboard}
          />
        </Collapse>
      </Box>
    </>
  );
};
